import React, { useState, useCallback } from 'react';
import { supabase } from './supabaseClient';
import * as XLSX from 'xlsx';
import {
  FileSpreadsheet, Download, Loader2, Calendar, Filter,
  TrendingUp, DollarSign, Package, AlertCircle, ChevronDown,
  ChevronUp, Search
} from 'lucide-react';

// ─── Zero-rated stock codes (from stock file where Excl === Incl) ───
const ZERO_RATED_CODES = new Set([
  '10325','10327','10328','10330','10331','10333','10336','10337','10345','10346','10347','11987','12105','12106','12110','12115','12833','12834','12836','12837','12946','13183','13186','14339','14342','14369','14370','14371','14373','14374',
  '14375','14821','15222','15226','15468','15469','15472','15473','15480','15482','15494','15495','15498','15500','15501','15502','15605','15606','15607','15608','15609','15610','15995','16003','16006','16016','16023','16025','16561','16563',
  '17334','17335','17336','19256','19258','19261','19262','19263','19265','19278','19280','19504','19505','19507','19508','19620','19624','19625','19753','19754','19756','19765','19766','19834','19836','21099','21100','21160','21162','21164',
  '21166','21198','21234','21271','21273','21274','21278','21287','21290','21416','21422','21423','21475','21553','21554','21594','21820','21990','21991','21992','22008','22010','22011','22012','22013','22015','22023','22024','22025','22029',
  '22151','22465','22508','22679','22749','22757','22759','22771','22773','22791','22792','23044','23047','23048','23056','23057','23143','23237','23281','23286','23375','23410','23439','23449','23452','23458','23459','23473','23489','23490',
  '23492','23494','23704','23825','23826','23828','23835','23836','23837','23838','23898','23922','24051','24053','24054','24055','24056','24057','24179','24300','24332','24466','24470','24527','24528','24707','24708','24752','24841','24977',
  '25098','25111','25305','25385','25386','25387','25394','25576','25661','25663','25914','25915','25916','25917','25918','25919','26097','26111','26112','26120','26127','26178','26204','26205','26565','26567','26586','26588','26679','26744',
  '26880','27075','27238','27292','27299','27300','27301','27303','27304','27305','27306','27307','27308','27309','27310','27682','27687','27789','28054','28067','28068','28073','28092','28093','28094','28095','28180','28181','28432','28433',
  '28437','28465','28521','28542','28699','28700','28701','28702','28703','28704','28792','28793','28925','28944','29270','29271','29341','29342','29343','29344','29431','29601','29890','29891','29913','29915','29919','29920','29921','29931',
  '29932','29946','29951','29952','29953','29954','30076','30077','30078','30120','30121','30122','30147','30148','30151','30152','30154','30164','30165','30226','30227','30228','30229','30230','30251','30275','30318','30417','30418','30435',
  '30484','30488','30500','30540','30553','30720','30736','30737','30740','30741','30742','30780','30781','30784','30785','30786','30787','30807','30808','30811','30812','30814','30816','30817','30818','30819','30820','30864','30901','30924',
  '30981','31022','31034','31211','31213','31436','31448','31671','31757','31758','31891','31895','31942','31943','31944','31945','31946','32097','32101','32147','32235','32552','32553','32610','32667','32668','32669','32670','32671','32677',
  '32680','32820','32990','33254','33275','33284','33294','33301','33302','33303','33345','33374','33375','33376','33389','33392','33418','33420','33447','33448','33469','33514','33538','33539','33739','33740','33741','33747','33798','33885',
  '33886','33887','34257','34258','34259','34260','34479','34482','34483','34562','34563','34605','34645','34648','34657','34658','34659','34660','34661','34662','34670','34779','34788','34790','34791','34837','34946','34959','35217','35299',
  '35352','35478','35479','35498','35704','35890','36091','36094','36110','36111','36190','36225','36246','36249','36252','36273','36274','36277','36350','36351','36435','36464','36479','36480','36484','36490','36494','36510','36535','36536',
  '36629','36630','36631','36646','36648','36675','36713','36806','36827','36841','36848','36956','36957','36994','37004','37031','37141','37208','37237','37258','37351','37395','37396','37397','37398','37399','37400','37401','37402','37403',
  '37475','37481','37559','37560','37568','37595','37613','37706','37725','37741','37793','37797','37823','37877','37878','37929','37994','37995','38061','38095','38135','38136','38226','38227','38323','38326','38337','38338','38339','38340',
  '38341','38342','38454','38489','38540','38541','38870','38966','38995','39170','39171','39225','39249','39250','39252','39307','39360','39361','39368','39369','39370','39371','39372','39495','39566','39567','39598','39613','39662','39663',
  '39664','39665','39666','39667','39668','39669','39670','39671','39673','39675','39718','39834','39860','39902','39903','40060','40061','40078','40165','40166','40239','40302','4038','40390','40524','40525','40527','40529','40557','40558',
  '40667','40677','40679','40683','40684','40832','40833','40927','40935','41080','41081','41082','41083','41088','41106','41118','41119','41132','41133','41155','41203','41204','41205','41206','41207','41220','41221','41222','41223','41224',
  '41225','41226','41227','41228','41240','41241','41242','41243','41246','41248','41249','41266','41267','41279','41281','41282','41283','41289','41291','41292','41310','41320','41459','41478','41483','41484','41485','41489','41490','41493',
  '41508','41618','41663','41693','41694','41695','41703','41706','41708','41719','41720','41721','41722','41723','41778','41786','41864','41865','41866','41867','41868','41869','41870','41871','41960','42054','42173','42290','42299','42300',
  '42301','42302','42303','42304','42305','42306','42307','42346','42371','42428','42429','4245','42526','42527','42529','42530','42531','42532','42533','42535','42537','42538','42539','42540','42541','42542','42543','42544','42545','42546',
  '42548','42551','42552','42555','42557','42558','42559','42560','42561','42562','42563','42564','42579','42584','42606','42607','42608','42611','42615','42616','42618','42619','42620','42621','42622','42624','42625','42627','42633','42637',
  '42672','42675','42676','42677','42678','42679','42682','42684','42688','42714','42715','42716','42717','42720','42725','42727','42772','42790','42791','42811','42861','42862','42929','42940','42948','42950','42952','42954','42977','43006',
  '43055','43056','43093','43109','43111','43115','43116','43117','43118','43164','43170','43172','43194','43196','43292','43333','43335','43364','43367','43369','43370','43371','43380','43381','43382','43398','43399','43401','43402','43403',
  '43421','43438','43440','43455','43456','43523','43540','43585','43586','43587','43588','43602','43604','43642','43649','43650','43675','43677','43678','43679','43680','43681','43682','43683','43684','43694','43695','43696','43703','43704',
  '43705','43706','43710','43749','43750','43754','43755','43758','43759','43762','43763','43769','43770','43774','43777','43800','43804','43805','43806','43807','43811','43812','43813','43815','43816','43817','43820','43821','43824','43829',
  '43830','43834','43837','43845','43853','43854','43855','43863','43869','43875','43923','43924','43926','43927','43934','43935','43936','43938','43939','43940','43941','43945','43946','43963','43973','43976','43979','43981','43992','43994',
  '43995','43996','43997','44001','44079','44080','44081','44088','44162','44164','44165','44204','44205','44206','44207','44307','44317','44327','44406','44500','44505','44530','44585','44613','44656','44681','44684','44685','44816','44860',
  '44867','44868','44869','44870','44871','44872','44881','44886','44906','44907','44932','44933','44955','44968','44976','45008','45027','45028','45086','45091','45092','45109','45112','45115','45138','45139','45140','45141','45146','45148',
  '45208','45209','45233','45257','45258','45259','45260','45261','45262','45271','45286','45327','45340','45358','5000','5020','5029','5030','5031','5032','5033','5034','5035','5036','5037','5038','5039','5040','5041','5042',
  '5043','5044','5045','5046','5047','5048','5049','5050','5051','5052','5053','5054','5055','5056','5057','5058','5059','5060','5061','5062','5063','5064','5065','5066','5067','5068','5069','5070','5071','5072',
  '5073','5075','5076','5077','5079','5080','5081','5082','5083','5084','5087','5088','5089','5091','5092','5094','5095','5097','5099','5100','5568','6000','6002','6003','6004','6005','6010','6012','6013','6014',
  '6015','6016','6017','6018','6019','6020','6101','7000','9096'
]);

// ─── Helpers ───
const isZeroRated = (stockCode) => {
  if (!stockCode) return false;
  const base = stockCode.includes('-') ? stockCode.split('-')[0] : stockCode;
  return ZERO_RATED_CODES.has(stockCode) || ZERO_RATED_CODES.has(base);
};

const fmt = (n) => `R ${(n || 0).toLocaleString('en-ZA', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const pct = (n) => `${((n || 0) * 100).toFixed(1)}%`;

// ─── Stat Card ───
const StatCard = ({ label, value, sub, icon: Icon, color }) => (
  <div className="bg-white rounded-xl border border-gray-200 p-5">
    <div className="flex items-center justify-between mb-2">
      <span className="text-sm text-gray-500">{label}</span>
      <div className={`w-9 h-9 rounded-lg flex items-center justify-center ${color}`}>
        <Icon size={18} className="text-white" />
      </div>
    </div>
    <div className="text-2xl font-bold text-gray-900">{value}</div>
    {sub && <div className="text-xs text-gray-400 mt-1">{sub}</div>}
  </div>
);

// ─── Main Component ───
export default function VATReportScreen() {
  const today = new Date();
  const firstOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
  
  const [dateFrom, setDateFrom] = useState(firstOfMonth.toISOString().slice(0, 10));
  const [dateTo, setDateTo] = useState(today.toISOString().slice(0, 10));
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [reportData, setReportData] = useState(null);
  const [vatFilter, setVatFilter] = useState('all'); // all | zero | standard
  const [searchTerm, setSearchTerm] = useState('');
  const [sortField, setSortField] = useState('invoice_date');
  const [sortDir, setSortDir] = useState('asc');
  const [viewMode, setViewMode] = useState('detail'); // detail | product
  const [showRows, setShowRows] = useState(100);

  // ─── Fetch all order line items for the period ───
  const fetchReport = useCallback(async () => {
    setLoading(true);
    setError(null);
    setShowRows(100);

    try {
      const startDate = new Date(dateFrom);
      startDate.setHours(0, 0, 0, 0);
      const endDate = new Date(dateTo);
      endDate.setHours(23, 59, 59, 999);

      // Supabase limits to 1000 rows per query — paginate
      let allItems = [];
      let page = 0;
      const pageSize = 1000;
      let hasMore = true;

      while (hasMore) {
        const { data, error: fetchErr } = await supabase
          .from('order_items')
          .select(`
            id,
            quantity,
            price,
            subtotal,
            order_id,
            product_id,
            orders!inner(order_number, created_at, status),
            products!inner(stock_code, name)
          `)
          .neq('orders.status', 'cancelled')
          .neq('orders.status', 'pending')
          .gte('orders.created_at', startDate.toISOString())
          .lte('orders.created_at', endDate.toISOString())
          .range(page * pageSize, (page + 1) * pageSize - 1)
          .order('id', { ascending: true });

        if (fetchErr) throw fetchErr;
        if (!data || data.length === 0) {
          hasMore = false;
        } else {
          allItems = [...allItems, ...data];
          if (data.length < pageSize) hasMore = false;
          page++;
        }
      }

      // Transform into report rows
      const rows = allItems.map(item => {
        const stockCode = item.products?.stock_code || '';
        const zeroRated = isZeroRated(stockCode);
        const lineAmount = parseFloat(item.subtotal) || 0;
        const sellExcl = zeroRated ? lineAmount : lineAmount / 1.15;
        const vatAmount = zeroRated ? 0 : lineAmount - sellExcl;

        return {
          invoice_number: item.orders?.order_number || '',
          invoice_date: item.orders?.created_at?.slice(0, 10) || '',
          stock_code: stockCode,
          item_description: item.products?.name || '',
          vat_category: zeroRated ? 'Zero-Rated' : 'Standard (15%)',
          quantity: item.quantity || 0,
          unit_price: parseFloat(item.price) || 0,
          line_amount: lineAmount,
          sell_excl: sellExcl,
          vat_amount: vatAmount,
        };
      });

      // Build product summary
      const prodMap = {};
      rows.forEach(r => {
        const key = `${r.stock_code}|${r.vat_category}`;
        if (!prodMap[key]) {
          prodMap[key] = {
            stock_code: r.stock_code,
            item_description: r.item_description,
            vat_category: r.vat_category,
            times_sold: new Set(),
            total_qty: 0,
            total_incl: 0,
            total_excl: 0,
            total_vat: 0,
          };
        }
        prodMap[key].times_sold.add(r.invoice_number);
        prodMap[key].total_qty += r.quantity;
        prodMap[key].total_incl += r.line_amount;
        prodMap[key].total_excl += r.sell_excl;
        prodMap[key].total_vat += r.vat_amount;
      });

      const productSummary = Object.values(prodMap)
        .map(p => ({ ...p, times_sold: p.times_sold.size }))
        .sort((a, b) => b.total_excl - a.total_excl);

      // Totals
      const totals = {
        lineItems: rows.length,
        orders: new Set(rows.map(r => r.invoice_number)).size,
        products: new Set(rows.map(r => r.stock_code)).size,
        totalQty: rows.reduce((s, r) => s + r.quantity, 0),
        revenueIncl: rows.reduce((s, r) => s + r.line_amount, 0),
        revenueExcl: rows.reduce((s, r) => s + r.sell_excl, 0),
        totalVAT: rows.reduce((s, r) => s + r.vat_amount, 0),
      };

      // Category breakdown
      const zeroRows = rows.filter(r => r.vat_category === 'Zero-Rated');
      const vatRows = rows.filter(r => r.vat_category === 'Standard (15%)');

      const categories = {
        zero: {
          lines: zeroRows.length,
          revenueIncl: zeroRows.reduce((s, r) => s + r.line_amount, 0),
          revenueExcl: zeroRows.reduce((s, r) => s + r.sell_excl, 0),
          vat: 0,
        },
        standard: {
          lines: vatRows.length,
          revenueIncl: vatRows.reduce((s, r) => s + r.line_amount, 0),
          revenueExcl: vatRows.reduce((s, r) => s + r.sell_excl, 0),
          vat: vatRows.reduce((s, r) => s + r.vat_amount, 0),
        },
      };

      setReportData({ rows, productSummary, totals, categories });
    } catch (err) {
      console.error('Report error:', err);
      setError(err.message || 'Failed to generate report');
    } finally {
      setLoading(false);
    }
  }, [dateFrom, dateTo]);

  // ─── Filter & sort rows for display ───
  const getFilteredRows = () => {
    if (!reportData) return [];
    let data = viewMode === 'detail' ? reportData.rows : reportData.productSummary;

    // VAT filter
    if (vatFilter === 'zero') data = data.filter(r => r.vat_category === 'Zero-Rated');
    else if (vatFilter === 'standard') data = data.filter(r => r.vat_category === 'Standard (15%)');

    // Search
    if (searchTerm) {
      const term = searchTerm.toLowerCase();
      data = data.filter(r =>
        r.item_description?.toLowerCase().includes(term) ||
        r.stock_code?.toLowerCase().includes(term) ||
        r.invoice_number?.toLowerCase().includes(term)
      );
    }

    // Sort
    data = [...data].sort((a, b) => {
      let valA = a[sortField], valB = b[sortField];
      if (typeof valA === 'string') valA = valA.toLowerCase();
      if (typeof valB === 'string') valB = valB.toLowerCase();
      if (valA < valB) return sortDir === 'asc' ? -1 : 1;
      if (valA > valB) return sortDir === 'asc' ? 1 : -1;
      return 0;
    });

    return data;
  };

  const toggleSort = (field) => {
    if (sortField === field) {
      setSortDir(d => d === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortDir('asc');
    }
  };

  const SortIcon = ({ field }) => {
    if (sortField !== field) return null;
    return sortDir === 'asc' ? <ChevronUp size={14} /> : <ChevronDown size={14} />;
  };

  // ─── Excel Download ───
  const downloadExcel = () => {
    if (!reportData) return;
    const wb = XLSX.utils.book_new();

    // Sheet 1: Sales Detail
    const detailData = reportData.rows.map(r => ({
      'Invoice Number': r.invoice_number,
      'Invoice Date': r.invoice_date,
      'Stock Code': r.stock_code,
      'Item Description': r.item_description,
      'VAT Category': r.vat_category,
      'Qty': r.quantity,
      'Unit Price (Incl)': r.unit_price,
      'Line Amount (Incl)': r.line_amount,
      'Revenue (Excl VAT)': Math.round(r.sell_excl * 100) / 100,
      'VAT Amount': Math.round(r.vat_amount * 100) / 100,
    }));
    const ws1 = XLSX.utils.json_to_sheet(detailData);
    ws1['!cols'] = [
      { wch: 22 }, { wch: 12 }, { wch: 12 }, { wch: 42 }, { wch: 15 },
      { wch: 6 }, { wch: 14 }, { wch: 16 }, { wch: 16 }, { wch: 14 }
    ];
    XLSX.utils.book_append_sheet(wb, ws1, 'Sales Detail');

    // Sheet 2: Product Summary
    const prodData = reportData.productSummary.map(p => ({
      'Stock Code': p.stock_code,
      'Item Description': p.item_description,
      'VAT Category': p.vat_category,
      'Times Sold': p.times_sold,
      'Total Qty': p.total_qty,
      'Revenue (Incl)': Math.round(p.total_incl * 100) / 100,
      'Revenue (Excl VAT)': Math.round(p.total_excl * 100) / 100,
      'VAT Amount': Math.round(p.total_vat * 100) / 100,
    }));
    const ws2 = XLSX.utils.json_to_sheet(prodData);
    ws2['!cols'] = [
      { wch: 12 }, { wch: 42 }, { wch: 15 }, { wch: 10 },
      { wch: 10 }, { wch: 16 }, { wch: 16 }, { wch: 14 }
    ];
    XLSX.utils.book_append_sheet(wb, ws2, 'Product Summary');

    // Sheet 3: VAT Summary
    const summaryData = [
      { 'Description': 'Total Revenue (Incl VAT)', 'Amount': Math.round(reportData.totals.revenueIncl * 100) / 100 },
      { 'Description': 'Total Revenue (Excl VAT)', 'Amount': Math.round(reportData.totals.revenueExcl * 100) / 100 },
      { 'Description': 'VAT Output (15%)', 'Amount': Math.round(reportData.totals.totalVAT * 100) / 100 },
      { 'Description': '', 'Amount': '' },
      { 'Description': 'Zero-Rated Sales', 'Amount': Math.round(reportData.categories.zero.revenueExcl * 100) / 100 },
      { 'Description': 'Standard Rated Sales (Excl)', 'Amount': Math.round(reportData.categories.standard.revenueExcl * 100) / 100 },
      { 'Description': 'Standard Rated VAT', 'Amount': Math.round(reportData.categories.standard.vat * 100) / 100 },
      { 'Description': '', 'Amount': '' },
      { 'Description': 'Total Orders', 'Amount': reportData.totals.orders },
      { 'Description': 'Total Line Items', 'Amount': reportData.totals.lineItems },
      { 'Description': 'Unique Products', 'Amount': reportData.totals.products },
    ];
    const ws3 = XLSX.utils.json_to_sheet(summaryData);
    ws3['!cols'] = [{ wch: 28 }, { wch: 18 }];
    XLSX.utils.book_append_sheet(wb, ws3, 'VAT Summary');

    const fromStr = dateFrom.replace(/-/g, '');
    const toStr = dateTo.replace(/-/g, '');
    XLSX.writeFile(wb, `Foodline_VAT_Report_${fromStr}_${toStr}.xlsx`);
  };

  const filteredRows = getFilteredRows();

  // ─── Quick period buttons ───
  const setPeriod = (months, label) => {
    const now = new Date();
    if (label === 'This Month') {
      setDateFrom(new Date(now.getFullYear(), now.getMonth(), 1).toISOString().slice(0, 10));
      setDateTo(now.toISOString().slice(0, 10));
    } else if (label === 'Last Month') {
      const first = new Date(now.getFullYear(), now.getMonth() - 1, 1);
      const last = new Date(now.getFullYear(), now.getMonth(), 0);
      setDateFrom(first.toISOString().slice(0, 10));
      setDateTo(last.toISOString().slice(0, 10));
    } else if (label === 'Last 3 Months') {
      const first = new Date(now.getFullYear(), now.getMonth() - 3, 1);
      setDateFrom(first.toISOString().slice(0, 10));
      setDateTo(now.toISOString().slice(0, 10));
    } else if (label === 'Year to Date') {
      setDateFrom(new Date(now.getFullYear(), 0, 1).toISOString().slice(0, 10));
      setDateTo(now.toISOString().slice(0, 10));
    }
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">VAT Report</h1>
          <p className="text-gray-500 mt-1">Sales analysis with VAT breakdown by period</p>
        </div>
        {reportData && (
          <button
            onClick={downloadExcel}
            className="flex items-center gap-2 px-5 py-2.5 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors font-medium"
          >
            <Download size={18} />
            Download Excel
          </button>
        )}
      </div>

      {/* Period Selection */}
      <div className="bg-white rounded-xl border border-gray-200 p-5">
        <div className="flex flex-col lg:flex-row lg:items-end gap-4">
          <div className="flex-1">
            <label className="block text-sm font-medium text-gray-700 mb-1">From Date</label>
            <input
              type="date"
              value={dateFrom}
              onChange={e => setDateFrom(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
            />
          </div>
          <div className="flex-1">
            <label className="block text-sm font-medium text-gray-700 mb-1">To Date</label>
            <input
              type="date"
              value={dateTo}
              onChange={e => setDateTo(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
            />
          </div>
          <button
            onClick={fetchReport}
            disabled={loading}
            className="flex items-center justify-center gap-2 px-6 py-2.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-blue-300 transition-colors font-medium min-w-[160px]"
          >
            {loading ? <Loader2 size={18} className="animate-spin" /> : <FileSpreadsheet size={18} />}
            {loading ? 'Generating...' : 'Generate Report'}
          </button>
        </div>

        {/* Quick period buttons */}
        <div className="flex flex-wrap gap-2 mt-3">
          {['This Month', 'Last Month', 'Last 3 Months', 'Year to Date'].map(label => (
            <button
              key={label}
              onClick={() => setPeriod(null, label)}
              className="px-3 py-1 text-xs font-medium bg-gray-100 text-gray-600 rounded-full hover:bg-gray-200 transition-colors"
            >
              {label}
            </button>
          ))}
        </div>
      </div>

      {/* Error */}
      {error && (
        <div className="bg-red-50 border border-red-200 rounded-lg p-4 flex items-center gap-3 text-red-700">
          <AlertCircle size={20} />
          <span>{error}</span>
        </div>
      )}

      {/* Report Results */}
      {reportData && (
        <>
          {/* Stat Cards */}
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
            <StatCard
              label="Revenue (Incl VAT)"
              value={fmt(reportData.totals.revenueIncl)}
              sub={`${reportData.totals.orders} orders`}
              icon={DollarSign}
              color="bg-blue-500"
            />
            <StatCard
              label="Revenue (Excl VAT)"
              value={fmt(reportData.totals.revenueExcl)}
              sub={`${reportData.totals.lineItems} line items`}
              icon={TrendingUp}
              color="bg-green-500"
            />
            <StatCard
              label="VAT Output (15%)"
              value={fmt(reportData.totals.totalVAT)}
              sub="Standard rated items"
              icon={FileSpreadsheet}
              color="bg-orange-500"
            />
            <StatCard
              label="Zero-Rated Sales"
              value={fmt(reportData.categories.zero.revenueExcl)}
              sub={`${reportData.categories.zero.lines} line items`}
              icon={Package}
              color="bg-purple-500"
            />
          </div>

          {/* Category Breakdown */}
          <div className="bg-white rounded-xl border border-gray-200 p-5">
            <h3 className="font-semibold text-gray-900 mb-4">VAT Category Breakdown</h3>
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b border-gray-200">
                    <th className="text-left py-2 px-3 text-gray-500 font-medium">Category</th>
                    <th className="text-right py-2 px-3 text-gray-500 font-medium">Line Items</th>
                    <th className="text-right py-2 px-3 text-gray-500 font-medium">Revenue (Incl)</th>
                    <th className="text-right py-2 px-3 text-gray-500 font-medium">Revenue (Excl)</th>
                    <th className="text-right py-2 px-3 text-gray-500 font-medium">VAT Amount</th>
                    <th className="text-right py-2 px-3 text-gray-500 font-medium">% of Sales</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b border-gray-100">
                    <td className="py-2.5 px-3 font-medium">Zero-Rated</td>
                    <td className="py-2.5 px-3 text-right">{reportData.categories.zero.lines.toLocaleString()}</td>
                    <td className="py-2.5 px-3 text-right">{fmt(reportData.categories.zero.revenueIncl)}</td>
                    <td className="py-2.5 px-3 text-right">{fmt(reportData.categories.zero.revenueExcl)}</td>
                    <td className="py-2.5 px-3 text-right text-gray-400">R 0.00</td>
                    <td className="py-2.5 px-3 text-right">{pct(reportData.categories.zero.revenueExcl / reportData.totals.revenueExcl)}</td>
                  </tr>
                  <tr className="border-b border-gray-100">
                    <td className="py-2.5 px-3 font-medium">Standard (15%)</td>
                    <td className="py-2.5 px-3 text-right">{reportData.categories.standard.lines.toLocaleString()}</td>
                    <td className="py-2.5 px-3 text-right">{fmt(reportData.categories.standard.revenueIncl)}</td>
                    <td className="py-2.5 px-3 text-right">{fmt(reportData.categories.standard.revenueExcl)}</td>
                    <td className="py-2.5 px-3 text-right font-medium text-orange-600">{fmt(reportData.categories.standard.vat)}</td>
                    <td className="py-2.5 px-3 text-right">{pct(reportData.categories.standard.revenueExcl / reportData.totals.revenueExcl)}</td>
                  </tr>
                  <tr className="bg-gray-50 font-semibold">
                    <td className="py-2.5 px-3">TOTAL</td>
                    <td className="py-2.5 px-3 text-right">{reportData.totals.lineItems.toLocaleString()}</td>
                    <td className="py-2.5 px-3 text-right">{fmt(reportData.totals.revenueIncl)}</td>
                    <td className="py-2.5 px-3 text-right">{fmt(reportData.totals.revenueExcl)}</td>
                    <td className="py-2.5 px-3 text-right text-orange-600">{fmt(reportData.totals.totalVAT)}</td>
                    <td className="py-2.5 px-3 text-right">100.0%</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* Filters & View Toggle */}
          <div className="bg-white rounded-xl border border-gray-200 p-5">
            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 mb-4">
              <div className="flex items-center gap-2">
                <button
                  onClick={() => setViewMode('detail')}
                  className={`px-4 py-1.5 rounded-lg text-sm font-medium transition-colors ${
                    viewMode === 'detail' ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                  }`}
                >
                  Line Items
                </button>
                <button
                  onClick={() => setViewMode('product')}
                  className={`px-4 py-1.5 rounded-lg text-sm font-medium transition-colors ${
                    viewMode === 'product' ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                  }`}
                >
                  Product Summary
                </button>
              </div>

              <div className="flex items-center gap-2">
                {/* VAT Filter */}
                <select
                  value={vatFilter}
                  onChange={e => setVatFilter(e.target.value)}
                  className="px-3 py-1.5 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-green-500"
                >
                  <option value="all">All Items</option>
                  <option value="zero">Zero-Rated Only</option>
                  <option value="standard">Standard (15%) Only</option>
                </select>

                {/* Search */}
                <div className="relative">
                  <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                  <input
                    type="text"
                    value={searchTerm}
                    onChange={e => setSearchTerm(e.target.value)}
                    placeholder="Search items..."
                    className="pl-9 pr-3 py-1.5 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-green-500 w-48"
                  />
                </div>
              </div>
            </div>

            {/* Results count */}
            <div className="text-xs text-gray-400 mb-3">
              Showing {Math.min(showRows, filteredRows.length)} of {filteredRows.length} {viewMode === 'detail' ? 'line items' : 'products'}
            </div>

            {/* Data Table */}
            <div className="overflow-x-auto">
              {viewMode === 'detail' ? (
                <table className="w-full text-sm">
                  <thead>
                    <tr className="border-b-2 border-gray-200">
                      <th onClick={() => toggleSort('invoice_number')} className="text-left py-2 px-2 text-gray-500 font-medium cursor-pointer hover:text-gray-700 whitespace-nowrap">
                        Invoice <SortIcon field="invoice_number" />
                      </th>
                      <th onClick={() => toggleSort('invoice_date')} className="text-left py-2 px-2 text-gray-500 font-medium cursor-pointer hover:text-gray-700 whitespace-nowrap">
                        Date <SortIcon field="invoice_date" />
                      </th>
                      <th className="text-left py-2 px-2 text-gray-500 font-medium">Code</th>
                      <th onClick={() => toggleSort('item_description')} className="text-left py-2 px-2 text-gray-500 font-medium cursor-pointer hover:text-gray-700">
                        Description <SortIcon field="item_description" />
                      </th>
                      <th className="text-center py-2 px-2 text-gray-500 font-medium">VAT</th>
                      <th className="text-center py-2 px-2 text-gray-500 font-medium">Qty</th>
                      <th className="text-right py-2 px-2 text-gray-500 font-medium">Unit Price</th>
                      <th onClick={() => toggleSort('line_amount')} className="text-right py-2 px-2 text-gray-500 font-medium cursor-pointer hover:text-gray-700 whitespace-nowrap">
                        Amount (Incl) <SortIcon field="line_amount" />
                      </th>
                      <th className="text-right py-2 px-2 text-gray-500 font-medium whitespace-nowrap">Excl VAT</th>
                      <th className="text-right py-2 px-2 text-gray-500 font-medium">VAT</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredRows.slice(0, showRows).map((r, i) => (
                      <tr key={i} className="border-b border-gray-100 hover:bg-gray-50">
                        <td className="py-1.5 px-2 text-xs font-mono">{r.invoice_number}</td>
                        <td className="py-1.5 px-2 text-xs">{r.invoice_date}</td>
                        <td className="py-1.5 px-2 text-xs text-gray-500">{r.stock_code}</td>
                        <td className="py-1.5 px-2 text-xs max-w-[200px] truncate">{r.item_description}</td>
                        <td className="py-1.5 px-2 text-center">
                          <span className={`inline-block px-2 py-0.5 rounded-full text-xs font-medium ${
                            r.vat_category === 'Zero-Rated' ? 'bg-green-100 text-green-700' : 'bg-orange-100 text-orange-700'
                          }`}>
                            {r.vat_category === 'Zero-Rated' ? '0%' : '15%'}
                          </span>
                        </td>
                        <td className="py-1.5 px-2 text-center text-xs">{r.quantity}</td>
                        <td className="py-1.5 px-2 text-right text-xs">{fmt(r.unit_price)}</td>
                        <td className="py-1.5 px-2 text-right text-xs font-medium">{fmt(r.line_amount)}</td>
                        <td className="py-1.5 px-2 text-right text-xs">{fmt(r.sell_excl)}</td>
                        <td className="py-1.5 px-2 text-right text-xs text-orange-600">{fmt(r.vat_amount)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <table className="w-full text-sm">
                  <thead>
                    <tr className="border-b-2 border-gray-200">
                      <th className="text-left py-2 px-2 text-gray-500 font-medium">Code</th>
                      <th onClick={() => toggleSort('item_description')} className="text-left py-2 px-2 text-gray-500 font-medium cursor-pointer hover:text-gray-700">
                        Description <SortIcon field="item_description" />
                      </th>
                      <th className="text-center py-2 px-2 text-gray-500 font-medium">VAT</th>
                      <th onClick={() => toggleSort('times_sold')} className="text-center py-2 px-2 text-gray-500 font-medium cursor-pointer hover:text-gray-700">
                        Sold <SortIcon field="times_sold" />
                      </th>
                      <th className="text-center py-2 px-2 text-gray-500 font-medium">Qty</th>
                      <th onClick={() => toggleSort('total_incl')} className="text-right py-2 px-2 text-gray-500 font-medium cursor-pointer hover:text-gray-700 whitespace-nowrap">
                        Revenue (Incl) <SortIcon field="total_incl" />
                      </th>
                      <th onClick={() => toggleSort('total_excl')} className="text-right py-2 px-2 text-gray-500 font-medium cursor-pointer hover:text-gray-700 whitespace-nowrap">
                        Revenue (Excl) <SortIcon field="total_excl" />
                      </th>
                      <th className="text-right py-2 px-2 text-gray-500 font-medium">VAT</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredRows.slice(0, showRows).map((r, i) => (
                      <tr key={i} className="border-b border-gray-100 hover:bg-gray-50">
                        <td className="py-1.5 px-2 text-xs text-gray-500">{r.stock_code}</td>
                        <td className="py-1.5 px-2 text-xs max-w-[250px] truncate">{r.item_description}</td>
                        <td className="py-1.5 px-2 text-center">
                          <span className={`inline-block px-2 py-0.5 rounded-full text-xs font-medium ${
                            r.vat_category === 'Zero-Rated' ? 'bg-green-100 text-green-700' : 'bg-orange-100 text-orange-700'
                          }`}>
                            {r.vat_category === 'Zero-Rated' ? '0%' : '15%'}
                          </span>
                        </td>
                        <td className="py-1.5 px-2 text-center text-xs">{r.times_sold}</td>
                        <td className="py-1.5 px-2 text-center text-xs">{r.total_qty}</td>
                        <td className="py-1.5 px-2 text-right text-xs font-medium">{fmt(r.total_incl)}</td>
                        <td className="py-1.5 px-2 text-right text-xs">{fmt(r.total_excl)}</td>
                        <td className="py-1.5 px-2 text-right text-xs text-orange-600">{fmt(r.total_vat)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>

            {/* Load More */}
            {showRows < filteredRows.length && (
              <div className="text-center mt-4">
                <button
                  onClick={() => setShowRows(s => s + 200)}
                  className="px-6 py-2 bg-gray-100 text-gray-600 rounded-lg hover:bg-gray-200 transition-colors text-sm font-medium"
                >
                  Load More ({filteredRows.length - showRows} remaining)
                </button>
              </div>
            )}
          </div>
        </>
      )}

      {/* Empty State */}
      {!reportData && !loading && (
        <div className="bg-white rounded-xl border border-gray-200 p-16 text-center">
          <FileSpreadsheet size={48} className="mx-auto text-gray-300 mb-4" />
          <h3 className="text-lg font-medium text-gray-600">Select a period and generate the report</h3>
          <p className="text-sm text-gray-400 mt-1">The report will show all sales with VAT breakdown</p>
        </div>
      )}
    </div>
  );
}
